import { Text, useMessage } from "melco-ui";

export type CopyableTextEllipsisProps = {
    text: string;
    onCopiedMessage?: string;
    copyTooltip?: string;
    copiedToolTip?: string;
    ellipsis?: boolean

}

export const CopyableTextEllipsis: React.FC<CopyableTextEllipsisProps> = ({
    text,
    onCopiedMessage,
    copyTooltip,
    copiedToolTip,
    ellipsis
}) => {
    const message = useMessage();
    return <>

        <Text
            ellipsis={ellipsis}
            copyable={{
                onCopy: () => {
                    message.success(onCopiedMessage)
                },
                tooltips: [copyTooltip, copiedToolTip]
            }}
            style={{ width: "100%" }}
        >
            {text}
        </Text >
    </>
}